export default __webpack_public_path__ + "static/LeituraSansTwo-BlackItalic-8e5a3fbf925b901b3378589e69a5ef34.woff2";